import React from "react";

const WhyUsDark = () => {
  return (
    <section className="py-20 px-6 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto text-center space-y-16">
        {/* Section Header */}
        <div>
          <p className="text-teal-400 font-semibold uppercase tracking-wide">
            Why TruPay
          </p>
          <h2 className="text-4xl md:text-5xl font-bold leading-tight max-w-3xl mx-auto mt-2">
            Maximize your returns with a reserve account that keeps working for
            you
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto text-left">
          {/* Card 1 */}
          <div className="relative bg-gray-800 p-8 rounded-lg shadow-lg overflow-hidden min-h-[220px] flex flex-col justify-center">
            <h3 className="text-8xl font-extrabold text-teal-400 mb-4">1</h3>

            <h4 className="text-xl font-semibold mb-2">Get Started Today</h4>
            <p className="text-gray-300 text-sm">
              Start your journey with TruPay by creating your personalized
              account today.
            </p>
          </div>

          {/* Card 2 */}
          <div className="relative bg-gray-800 p-8 rounded-lg shadow-lg overflow-hidden min-h-[220px] flex flex-col justify-center">
            <h3 className="text-8xl font-extrabold text-teal-400 mb-4">2</h3>

            <h4 className="text-xl font-semibold mb-2">Sign Up to TruPay</h4>
            <p className="text-gray-300 text-sm">
              Quickly register and set up your dashboard to effortlessly manage
              all your payments.
            </p>
          </div>

          {/* Card 3 */}
          <div className="relative bg-gray-800 p-8 rounded-lg shadow-lg overflow-hidden min-h-[220px] flex flex-col justify-center">
            <h3 className="text-8xl font-extrabold text-teal-400 mb-4">3</h3>

            <h4 className="text-xl font-semibold mb-2">Grow with Confidence</h4>
            <p className="text-gray-300 text-sm">
              Leverage our secure platform designed to scale with your business
              needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUsDark;
